// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"7e623d30","635":"7e623d30"}[chunkId] + ".chunk.css";
};